import ADMDGraph from "./ADMDGraph";
import * as React from "react";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useGetADMDGraphDataQuery } from "../api/apiSlice";
import GDGraph from "./GeyserDemandPercentageGraph";
import ADPGraph from "./ADPGraph";
import DarkDateRangePicker from "../OperatorDashboard/DarkDateRangePicker";

const styles = {
  container: {
    margin: "0 auto",
    padding: "70px 32px 40px",
    maxWidth: "1440px",
  },
};

export default function ADMDPage() {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [start_date, setstart_date] = React.useState(dayjs().subtract(1, "day"));
  const [end_date, setEnd_date] = React.useState(dayjs());

  const request = {
    start_date: start_date.format("YYYY-MM-DD"),
    end_date: end_date.format("YYYY-MM-DD"),
    user_timezone: userTimezone,
  };

  const { data: admd_data } = useGetADMDGraphDataQuery(request);

  return (
    <Box style={styles.container}>
      {/* Page header */}
      <Box sx={{ pt: "28px", mb: "24px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
        <Box>
          <Typography sx={{ fontSize: "1.7rem", fontWeight: 700, color: "#fff", letterSpacing: "-0.025em", lineHeight: 1.2 }}>
            ADD
          </Typography>
          <Typography sx={{ fontSize: "0.88rem", color: "rgba(255,255,255,0.45)", mt: "4px" }}>
            After Maximum Demand · custom date range
          </Typography>
        </Box>
        <DarkDateRangePicker
          compact
          startDate={start_date}
          endDate={end_date}
          onApply={(start, end) => { setstart_date(start); setEnd_date(end); }}
        />
      </Box>

      <Grid container direction="column" gap={2}>
        <Grid item>
          <ADMDGraph graph_data={admd_data} />
        </Grid>
        <Grid item>
          <GDGraph graph_data={admd_data} />
        </Grid>
        <Grid item>
          <ADPGraph startDate={start_date} endDate={end_date} />
        </Grid>
      </Grid>
    </Box>
  );
}
